import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"

export function ResetToaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {/* {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast className="bg-red-700" id="toast-wrapper" key={id} {...props}>
            <div className="grid text-white">
              {title && <ToastTitle className="text-2xl">{title}</ToastTitle>}
              {description && (
                <ToastDescription className="text-xl">{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })} */}
      <ToastViewport />
    </ToastProvider>
  )
}
